import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Clock, AlertCircle, CheckCircle2, Building } from 'lucide-react';

const VoivodeshipTimes = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/processing-times')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Processing Times
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Average Processing Times by Voivodeship
          </h1>
          <p className="text-muted-foreground">
            Compare residence permit processing times across different Polish voivodeships and understand what affects processing duration.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Clock className="h-5 w-5 text-primary mr-2" />
                Current Processing Times
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <Building className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Małopolski (Kraków):</span> 3-4 months average
                  </div>
                </li>
                <li className="flex items-start">
                  <Building className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Pomorski (Gdańsk):</span> 3-5 months average
                  </div>
                </li>
                <li className="flex items-start">
                  <Building className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Dolnośląski (Wrocław):</span> 6-24 months average
                  </div>
                </li>
                <li className="flex items-start">
                  <Building className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  <div>
                    <span className="font-semibold">Mazowiecki (Warsaw):</span> 6-12 months average
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <CheckCircle2 className="h-5 w-5 text-primary mr-2" />
                Factors Affecting Processing Time
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Application volume in the voivodeship
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Completeness of submitted documentation
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Type of residence permit requested
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Additional verification requirements
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Important Notes
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Legal processing time limit is 60 days, but this is often exceeded
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  You can legally stay and work while your application is being processed
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Processing times may vary significantly based on current workload
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Some offices offer expedited processing for certain cases
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Help Tracking Your Application?</h2>
            <p className="text-muted-foreground mb-4">
              Most voivodeship offices now offer online tracking systems to check your application status.
            </p>
            <button 
              onClick={() => navigate('/knowledge-base/processing-times/track-status')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Learn How to Track Status
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoivodeshipTimes; 